import { render, staticRenderFns } from "./Biblioteca.vue?vue&type=template&id=bf38866e&scoped=true&"
import script from "./Biblioteca.vue?vue&type=script&lang=js&"
export * from "./Biblioteca.vue?vue&type=script&lang=js&"
import style0 from "./Biblioteca.vue?vue&type=style&index=0&id=bf38866e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf38866e",
  null
  
)

export default component.exports